import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Link } from 'components/core/Link';
import { Text } from 'components/core/Typography';
import { ChevronRight } from 'components/svg';
import FeeWarningToolTip from 'components/fees/FeeWarningToolTip';

import { getNumericalValue } from 'utils/format';

import './UnitPrice.scss';

export class UnitPrice extends PureComponent {
	static propTypes = {
		priceValue: PropTypes.number,
		/** The regular price of a unit, if provided it is shown with a strikethrough */
		regularPrice: PropTypes.string,
		/** If the price text should be a link */
		linkedPrice: PropTypes.bool,
		showPeriod: PropTypes.bool,
		link: PropTypes.string,
		size: PropTypes.string,
		priceDollars: PropTypes.string.isRequired,
		priceCents: PropTypes.string.isRequired,
		isScarce: PropTypes.bool,
		unitQuantity: PropTypes.number,
		showFees: PropTypes.bool,
		fees: PropTypes.object,
	};

	static defaultProps = {
		linkedPrice: true,
		showPeriod: false,
		size: 'medium',
	};

	_renderPrice() {
		const { priceDollars, priceCents } = this.props;
		if (!this.props.linkedPrice) {
			return (
				<Text
					className={classnames('price')}
					size={this.props.size}
					last
				>
					${priceDollars}
					<sup className="cents">.{priceCents}</sup>
				</Text>
			);
		}

		return (
			<Link
				href={this.props.link}
				className="price"
				hideBorder
			>
				<Text
					className={classnames('price', {
						'scarcity-price': this.props.isScarce,
					})}
					strong
					size={this.props.size}
				>
					${priceDollars}
					<sup className="cents">.{priceCents}</sup>
				</Text>
			</Link>
		);
	}

	_renderRegularPrice() {
		const { regularPrice, priceValue } = this.props;
		if (!regularPrice || getNumericalValue(regularPrice) <= priceValue) {
			return null;
		}

		return (
			<Text
				className="regular-price"
				strikethrough
				last
			>
				${regularPrice}
			</Text>
		);
	}

	_renderPeriod() {
		if (!this.props.showPeriod) {
			return null;
		}

		return (
			<Text
				className="payment-period"
				last
			>
				per month
			</Text>
		);
	}

	_renderFees() {
		if (!this.props.showFees || !this.props?.fees?.totalFees?.value) {
			return null;
		}

		return (
			<FeeWarningToolTip
				feeProps={this.props.fees}
				className="fee-tooltip"
				variation={true}
			/>
		);
	}

	render() {
		return (
			<div className={classnames('atomic-unit-price', 'unit-price')}>
				<div className="price-container">
					<div className="price-row">
						{this._renderRegularPrice()}
						{this._renderPrice()}
					</div>
					{this._renderPeriod()}
					<ChevronRight fill="black" />
				</div>
				{this._renderFees()}
			</div>
		);
	}
}

const EnhancedUnitPrice = (props) => {
	const { price } = props;
	const [dollars, cents] = price.toString().split('.');
	const enhancedProps = {
		priceValue: parseFloat(price.replace(/,/g, '')),
		priceDollars: dollars,
		priceCents: cents || '00',
	};
	return (
		<UnitPrice
			{...props}
			{...enhancedProps}
		/>
	);
};

export default EnhancedUnitPrice;
